<script setup>
import { computed, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore } from 'dashboard/composables/store';
import { useAccount } from 'dashboard/composables/useAccount';
import { useRouteTabs } from 'dashboard/composables/useRouteTabs';
import RouteTabs from 'dashboard/components-next/tabbar/RouteTabs.vue';
import TabsPageHeader from 'dashboard/components-next/tabbar/TabsPageHeader.vue';

defineProps({
  keepAlive: { type: Boolean, default: true },
});

const { t } = useI18n();
const store = useStore();
const { accountScopedRoute } = useAccount();

const tabs = computed(() => [
  {
    key: 'single',
    label: t('CAMPAIGN.PAGE.TABS.SINGLE'),
    icon: 'i-lucide-send',
    to: accountScopedRoute('campaigns_whatsapp_index'),
    activeOn: ['campaigns_whatsapp_index'],
    description: t('CAMPAIGN.PAGE.SINGLE.DESCRIPTION'),
  },
  {
    key: 'multi_step',
    label: t('CAMPAIGN.PAGE.TABS.MULTI_STEP'),
    icon: 'i-lucide-layers',
    to: accountScopedRoute('campaigns_multi_step_index'),
    activeOn: ['campaigns_multi_step_index'],
    description: t('CAMPAIGN.PAGE.MULTI_STEP.DESCRIPTION'),
    linkText: t('CAMPAIGN.PAGE.MULTI_STEP.LEARN_MORE'),
    linkUrl: t('WHATSAPP_FLOWS.TUTORIAL_URL'),
  },
]);

const { visibleTabs, activeTab } = useRouteTabs(tabs);

onMounted(() => {
  store.dispatch('campaigns/get');
  store.dispatch('labels/get');
});
</script>

<template>
  <div
    class="flex flex-col flex-1 h-full m-0 overflow-auto bg-n-background px-6"
  >
    <div
      v-if="activeTab"
      class="flex flex-col w-full max-w-[60rem] mx-auto gap-4 flex-shrink-0"
    >
      <TabsPageHeader
        :title="t('CAMPAIGN.PAGE.HEADER')"
        :help-url="t('CAMPAIGN.PAGE.HELP_URL')"
      />
      <RouteTabs :tabs="visibleTabs" :active-key="activeTab.key" />
      <p class="mb-0 text-sm text-n-slate-11">
        {{ activeTab.description }}
        <a
          v-if="activeTab.linkUrl"
          :href="activeTab.linkUrl"
          target="_blank"
          rel="noopener noreferrer"
          class="font-medium text-n-blue-text hover:underline"
        >
          {{ activeTab.linkText }}
        </a>
      </p>
    </div>
    <router-view v-slot="{ Component }">
      <keep-alive v-if="keepAlive">
        <component :is="Component" />
      </keep-alive>
      <component :is="Component" v-else />
    </router-view>
  </div>
</template>
